<template>
    <div class="feedItem d-flex panel bg-lightest black" v-if="showThisCard">
            <div class="leftSide d-flex flex-column align-items-center border-right-dark justify-content-center">
                <img :src="selectedOta.logo" style="max-height: 130px; max-width: 130px;" alt="">
                <a :href="selectedOta.website" target="_blank" class="mt-4 color-1 bold underlined">Go to Website</a>
            </div>

            <div class="rightSide d-flex flex-column p-4">

                <div class="d-flex flex-column flex-grow-1">
                    <!-- title -->
                    <div class="fs-larger bold">{{selectedOta.name}} is here!</div>

                    <!-- text -->
                    <div class="mt-3">{{selectedOta.description}}</div>
                </div>

                <div class="d-flex">
                    <!-- button -->
                    <button class="btn blue w-100" @click="learnMoreClick">Learn More</button>
                </div>

            </div>

    </div>
</div>

</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
    data: function() {
        return{
        }
    },
    computed:{
        ...mapGetters([
            'account',
            'getOTAs',
        ]),
        showThisCard: function () {
            return true
            // if(process.env.NODE_ENV == 'stage' || process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'qa'){
            //     return true
            // }

            // show for "EasyDivers" + "Seaventy"
            // return this.account.supplier.id == 31 || this.account.supplier.id == 69
        },
        selectedOta: function () {
            return this.getOTAs.find(ota => ota.id == this.cardInfo.otaId)
        }
    },
    methods:{
        ...mapActions([
            'openComponentModal'
        ]),
        learnMoreClick: function () {
            this.openComponentModal(this.selectedOta.howToConnect)
        }
    },
    props: {
        cardInfo: {
            type: Object
        }
    }
}

</script>

<style scoped lang="scss" scoped>
@import '../../assets/scss/_variables.scss';

.feedItem{
    padding: 0;
    height: 240px !important;

    .leftSide{
        min-width: 210px;
    }

    .rightSide{

    }

}

</style>



// WEBPACK FOOTER //
// FeedcardNewOTA.vue?689dcd34